import RoleHome from '../../components/RoleHome/RoleHome';
export default function CourierHome() {
  return <RoleHome role="courier" />;
}